/* Change this file to get your personal Porfolio */

// Website related settings
const settings = {
  isSplash: false, // Change this to false if you don't want Splash screen.
};

//SEO Related settings
const seo = {
  title: "Vamsi's Portfolio",
  description:
    "A passionate individual who always thrives to work on end to end products which develop sustainable and scalable social and technical systems to create impact.",
  og: {
    title: "Vamsi Manda Portfolio",
    type: "website",
  },
};

//Home Page
const greeting = {
  title: "Vamsi Manda",
  logo_name: "Vamsi Manda",
  subTitle:
    "A passionate individual who always thrives to work on end to end products which develop sustainable and scalable social and technical systems to create impact.",
  resumeLink:
    "https://drive.google.com/file/d/10c1JqXXHPf7ewLNmNC0Y9y-vANasHvl1/view?usp=sharing",
  portfolio_repository: "https://github.com/Vamsi404/Vamsi404.github.io",
  githubProfile: "https://github.com/Vamsi404",
};

const socialMediaLinks = [

  {
    name: "Github",
    link: "https://github.com/Vamsi404",
    fontAwesomeIcon: "fa-github", // Reference https://fontawesome.com/icons/github?style=brands
    backgroundColor: "#181717", // Reference https://simpleicons.org/?q=github
  },
  {
    name: "LinkedIn",
    link: "https://www.linkedin.com/in/vamsi-manda-b87151193/",
    fontAwesomeIcon: "fa-linkedin-in", // Reference https://fontawesome.com/icons/linkedin-in?style=brands
    backgroundColor: "#0077B5", // Reference https://simpleicons.org/?q=linkedin
  },
  {
    name: "Gmail",
    link: "mailto:vamsimanda0330@gmail.com",
    fontAwesomeIcon: "fa-google", // Reference https://fontawesome.com/icons/google?style=brands
    backgroundColor: "#D14836", // Reference https://simpleicons.org/?q=gmail
  },
  {
    name: "X-Twitter",
    link: "https://x.com/VamsiManda76858",
    fontAwesomeIcon: "fa-x-twitter", // Reference https://fontawesome.com/icons/x-twitter?f=brands&s=solid
    backgroundColor: "#000000", // Reference https://simpleicons.org/?q=x
  },
  {
    name: "Instagram",
    link: "https://www.instagram.com/m.vamsi._/",
    fontAwesomeIcon: "fa-instagram", // Reference https://fontawesome.com/icons/instagram?style=brands
    backgroundColor: "#E4405F", // Reference https://simpleicons.org/?q=instagram
  },
];

const skills = {
  data: [
    {
      title: "Data Science & AI",
      fileName: "DataScienceImg",
      skills: [
        "⚡ Developing highly scalable production ready models for various deeplearning and statistical use cases",
        "⚡ Experience of working with LLMs and classical machine learning models",
        "⚡ Knowledge of various LLMs like FLAN-T5, GPT-3, BERT, etc. and their working",
      ],
      softwareSkills: [
        {
          skillName: "Tensorflow",
          fontAwesomeClassname: "logos-tensorflow",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Keras",
          fontAwesomeClassname: "simple-icons:keras",
          style: {
            backgroundColor: "white",
            color: "#D00000",
          },
        },
        {
          skillName: "PyTorch",
          fontAwesomeClassname: "logos-pytorch",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Python",
          fontAwesomeClassname: "ion-logo-python",
          style: {
            backgroundColor: "transparent",
            color: "#3776AB",
          },
        },
        {
          skillName: "Deeplearning",
          imageSrc: "deeplearning_ai_logo.png",
        },
      ],
    },
    {
      title: "Full Stack Development",
      fileName: "FullStackImg",
      skills: [
        "⚡ Building responsive website front end using React-Redux",
        "⚡ Experience in developing RESTful APIs",
        "⚡ Creating application backend in Node, Express & Flask",
      ],
      softwareSkills: [
        {
          skillName: "HTML5",
          fontAwesomeClassname: "simple-icons:html5",
          style: {
            color: "#E34F26",
          },
        },
        {
          skillName: "CSS3",
          fontAwesomeClassname: "fa-css3",
          style: {
            color: "#1572B6",
          },
        },
        {
          skillName: "JavaScript",
          fontAwesomeClassname: "simple-icons:javascript",
          style: {
            backgroundColor: "#000000",
            color: "#F7DF1E",
          },
        },
        {
          skillName: "ReactJS",
          fontAwesomeClassname: "simple-icons:react",
          style: {
            color: "#61DAFB",
          },
        },
        {
          skillName: "NodeJS",
          fontAwesomeClassname: "devicon-plain:nodejs-wordmark",
          style: {
            color: "#339933",
          },
        },
        {
          skillName: "NPM",
          fontAwesomeClassname: "simple-icons:npm",
          style: {
            color: "#CB3837",
          },
        },
        {
          skillName: "Flutter",
          fontAwesomeClassname: "simple-icons:flutter",
          style: {
            color: "#02569B",
          },
        },
      ],
    },
    {
      title: "Cloud Infra-Architecture",
      fileName: "CloudInfraImg",
      skills: [
        "⚡ Experience working on multiple cloud platforms",
        "⚡ Hosting and maintaining websites on virtual machine instances along with integration of databases",
        "⚡ Deploying deep learning models on cloud to use on mobile devices",
        "⚡ Setting up streaming jobs from DB to Server or vice-versa on GCP and AWS",
      ],
      softwareSkills: [
        {
          skillName: "AWS",
          fontAwesomeClassname: "simple-icons:amazonaws",
          style: {
            color: "#FF9900",
          },
        },
        {
          skillName: "Azure",
          fontAwesomeClassname: "simple-icons:microsoftazure",
          style: {
            color: "#0089D6",
          },
        },
        {
          skillName: "Firebase",
          fontAwesomeClassname: "simple-icons:firebase",
          style: {
            color: "#FFCA28",
          },
        },
        {
          skillName: "MongoDB",
          fontAwesomeClassname: "simple-icons:mongodb",
          style: {
            color: "#47A248",
          },
        },
        {
          skillName: "OCI",
          fontAwesomeClassname: "simple-icons:docker",
          style: {
            color: "#1488C6",
          },
        },
      ],
    },
  ],
};

// Education Page
const competitiveSites = {
  competitiveSites: [
    {
      siteName: "LeetCode",
      iconifyClassname: "simple-icons:leetcode",
      style: {
        color: "#F79F1B",
      },
      profileLink: "https://leetcode.com/u/marribadal/",
    },
    {
      siteName: "Codechef",
      iconifyClassname: "simple-icons:codechef",
      style: {
        color: "#5B4638",
      },
      profileLink: "https://www.codechef.com/users/mvamsi",
    },
  ],
};

const degrees = {
  degrees: [
    {
      title: "University Of Florda",
      subtitle: "M.S. in Computer Science",
      logo_path: "uf.png",
      alt_name: "UF Gainesville",
      duration: "2023 - 2025",
      descriptions: [
        "⚡ I have studied advanced subjects like Advanced Data Structures, Distributed Operating System Principles, Mathematics for Intelligent Systems, Machine Learning, and Software Engineering.",
        "⚡ Apart from this, I have done courses on Generative AI, Node.js, Kafka, MongoDB, and Tableau, and I have also worked on hands-on projects through these classes.",
        "⚡ I was awarded the scholarship for my excellent performance in my undergraduate semester exams.",
      ],
      website_link: "https://www.ufl.edu/",
    },
    {
      title: "Veer Surendra Sai University Of Technology",
      subtitle: "Bachelor's in Electrical Engineering",
      logo_path: "Logo_vssut.svg.png",
      alt_name: "VSSUT Burla",
      duration: "2019 - 2023",
      descriptions: [
        "⚡ I have taken varity of courses like Data Structures,Machine Learning,Computer Networks,etc.",
        "⚡ I have been part of the robotics club at my college, where I coded for the bots, enabling different types of motion, including holonomic",
        "⚡ During my time at university, I was also associated with multimedia department. As part of it, I have worked on some documentry films and interviews.",
      ],
      website_link: "https://www.vssut.ac.in/",
    },
  ],
};

const certifications = {
  certifications: [
    {
      title: "Solutions Architect-Associate",
      subtitle: "- AWS",
      logo_path: "aws.png",
      certificate_link:
        "https://drive.google.com/file/d/11RQFmjJorvqxg_xQuleqn_Ga4-fi-7jO/view?usp=sharing",
      alt_name: "Amazon Web Services",
      color_code: "#8C151599",
    },
    {
      title: "Artificial Intelligence",
      subtitle: "- Damien Carey",
      logo_path: "deeplearning_ai_logo.png",
      certificate_link:
        "https://drive.google.com/file/d/1XcdUeMZY4z8Hg2QJHj3ArPl8zDqvJCgO/view?usp=sharing",
      alt_name: "Oracle Cloud Infrastructure",
      color_code: "#00000099",
    },
    {
      title: "Gen AI",
      subtitle: "- OCI",
      logo_path: "oracle1.png",
      certificate_link:
        "https://drive.google.com/file/d/1XcdUeMZY4z8Hg2QJHj3ArPl8zDqvJCgO/view?usp=sharing",
      alt_name: "Oracle",
      color_code: "#0C9D5899",
    },
    {
      title: "Networking Professional",
      subtitle: "- Atul Vikas Lakra",
      logo_path: "cisco.png",
      certificate_link:
        "https://drive.google.com/file/d/1hWcKKeqBd5QcgGZNKSUGqo_dbqsMWog8/view?usp=sharing",
      alt_name: "Cisco",
      color_code: "#1F70C199",
    },
    
  ],
};

// Experience Page
const experience = {
  title: "Experience",
  subtitle: "Internship and Volunteership",
  description:
    " I have worked with startups and clubs as an ML and web developer. I have also been the secretary of the robotics club in my undergraduate college, where I worked on various projects like the Ultra Violet Radiation and Sanitization System (UVRAS) and won prizes for the club.",
  header_image_path: "experience.svg",
  sections: [
    {
      title: "Training & Internships",
      work: true,
      experiences: [
        {
          title: "Machine Learning Engineer",
          company: "Coratia Technologies.",
          company_url: "https://coratia.com/",
          logo_path: "coratia.jpeg",
          duration: "May 2022 - July 2022",
          location: "Odisha,India",
          description:
            "Significant enhancements have been achieved in real-time underwater image and video quality, particularly in challenging conditions characterized by high turbidity and low light, resulting in remarkable improvements in image clarity and noise +reduction.",
          color: "#000000",
        },
        {
          title: "Machine Learning Trainee",
          company: "Amazon",
          company_url: "https://xathon.mettl.com/event/amazonmlsummerschool",
          logo_path: "amazon.png",
          duration: "July 2022 - Aug 2022",
          description:
            "Thoroughly immersed in the core tenets of machine learning, enriching knowledge, and effectively bridging the gap between theoretical concepts and practical applications. Conducted a comprehensive exploration of supervised learning,deep neural networks, probabilistic graphical models, dimensionality reduction, unsupervised learning, and sequential models, resulting in a profound 25% increase in overall understanding of the field.",
          color: "#0879bf",
        },
        {
          title: "Web Developer",
          company: "Techgyan Technologies",
          company_url: "https://tech-gyan.in/",
          logo_path: "techgyan1.png",
          duration: "January 2021 - March 2021",
          location: "Odisha,India",
          description:
            "Completed a web developer internship where I developed and maintained dynamic web applications using technologies such as Node.js, MongoDB, and Express.js. Gained hands-on experience in coding, debugging, and collaborating with cross-functional teams to deliver user-friendly and efficient web solutions. Enhanced my skills in full-stack development and contributed to several successful projects.",
          color: "#9b1578",
        },
        {
          title: "IOT & ML Intern",
          company: "Swan Labs",
          company_url: "https://cse.iitkgp.ac.in/~smisra/swan/",
          logo_path: "SWAN-Logo.png",
          duration: "August 2021 - Novemeber 2021",
          location: "West Bengal,India",
          description:
            "Developed a multi-sensor IoT module using Raspberry Pi for real-time AQI analysis at traffic intersections, achieving 85% prediction accuracy. Automated monitoring via a cloud-based alert system, reducing response times by 30%",
          color: "#9b1578",
        },
      ],
    },
    {
      title: "Volunteerships",
      experiences: [
        {
          title: "Idea and Innovation cell",
          company: "VSSUT",
          company_url: "https://idea-innovation-cell-vssut.github.io/version_1/",
          logo_path: "hero_iic.png",
          duration: "December 2019 - August 2021",
          location: "Burla, Odisha",
          description:
            "Worked on projects such as the digitization of local restaurants, marking the start of my development career. Designed numerous portfolios and contributed to projects like the VSSUT Satellite Launch Vehicle (VSLV).",
          color: "#4285F4",
        },
        {
          title: "Robotics Society",
          company: "VSSUT",
          company_url: "https://www.vssutroboticssociety.com/",
          logo_path: "robotics.jpeg",
          duration: "Aug 2021 - May 2023",
          location: "Burla, Odisha",
          description:
            "Served as the secretary of the club in my pre-final year and worked on projects such as an automatic bomb detection and diffusion bot, which won a prize at the International Space Week competition organized jointly by NASA and ISRO in Cuttack, India.",
          color: "#D83B01",
        },
      ],
    },
  ],
};

// Projects Page
const projectsHeader = {
  title: "Projects",
  description:
    "My projects makes use of vast variety of latest technology tools. My best experience is to create Data Science projects and deploy them to web applications using cloud infrastructure.",
  avatar_image_path: "projects_image.svg",
};

const publicationsHeader = {
  title: "Publications",
  description: "Some of my published Articles, Blogs and Research.",
  avatar_image_path: "projects_image.svg",
};

const publications = {
  data: [
    {
      id: "neuro-symbolic-sudoku-solver",
      name: "Neuro-Symbolic Sudoku Solver",
      createdAt: "2023-07-02T00:00:00Z",
      description: "Paper published in KDD KiML 2023",
      url: "https://arxiv.org/abs/2307.00653",
    },
    {
      id: "mdp-diffusion",
      name: "MDP-Diffusion",
      createdAt: "2023-09-19T00:00:00Z",
      description: "Blog published in Paperspace",
      url: "https://blog.paperspace.com/mdp-diffusion/",
    },
    {
      id: "consistency-models",
      name: "Consistency Models",
      createdAt: "2023-10-12T00:00:00Z",
      description: "Blog published in Paperspace",
      url: "https://blog.paperspace.com/consistency-models/",
    },
  ],
};

// Contact Page
const contactPageData = {
  contactSection: {
    title: "Contact Me",
    profile_image_path: "IMG-20200914-WA0003.png",
    description:
      "I am available on almost every social media. You can message me, I will reply within 24 hours. I can help you with ML, AI, React and Cloud and Opensource Development.",
  },
  blogSection: {
    title: "Blogs",
    subtitle:
      "I like to document some of my experiences in professional career journey as well as some technical knowledge sharing.",
    link: "https://blogs.ashutoshhathidara.com/",
    avatar_image_path: "blogs_image.svg",
  },
  addressSection: {
    title: "Address",
    subtitle: "Stoneridge Apartments, Gainesville, FL, USA 32608",
    locality: "Gainesville",
    country: "USA",
    region: "Florida",
    postalCode: "32608",
    streetAddress: "3800 SW 34th Street",
    avatar_image_path: "address_image.svg",
    location_map_link: "https://www.google.com/maps/place/Stoneridge+Apartments+in+Gainesville/@29.6185875,-82.3773644,16z/data=!3m1!4b1!4m6!3m5!1s0x88e8a326155c6e27:0x35f8d276043cfe51!8m2!3d29.6185875!4d-82.3747895!16s%2Fg%2F1v1vf05j?entry=ttu",
  },
  phoneSection: {
    title: "Phone",
    subtitle: "+13527454374",
  },
};

export {
  settings,
  seo,
  greeting,
  socialMediaLinks,
  skills,
  competitiveSites,
  degrees,
  certifications,
  experience,
  projectsHeader,
  publicationsHeader,
  publications,
  contactPageData,
};
